import React from "react";

/**
 * Username — Renders a user's display name with role-appropriate styling.
 *
 * Special treatment:
 *  • role === "admin"  →  Founder gradient (#ff6b6b → #d10000 → #7a0000) with crimson glow.
 *
 * All other roles render plain text so they integrate with the parent's typography.
 * Usage: <Username user={u} />  or  <Username name={u.name} role={u.role} />
 */
export default function Username({ user, name, role, className = "", as = "span" }) {
  const effectiveName = (user?.name ?? name ?? "").trim() || "Anonymous";
  const effectiveRole = user?.role ?? role ?? "member";
  const Tag = as;
  if (effectiveRole === "admin") {
    return (
      <Tag className={`username-founder ${className}`} title="Founder">
        {effectiveName}
      </Tag>
    );
  }
  return <Tag className={className}>{effectiveName}</Tag>;
}
